import { render } from "./MsgItem.vue?vue&type=template&id=7bc15096&scoped=true"
import script from "./MsgItem.vue?vue&type=script&lang=js"
export * from "./MsgItem.vue?vue&type=script&lang=js"

import "./MsgItem.vue?vue&type=style&index=0&id=7bc15096&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE\\zoopay\\zoopay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc15096"]])

export default __exports__